import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CELLS } from "@/lib/cells/cells";
import { cn } from "@/lib/utils";

/** "Cell: All cells / US / EU". Renders nothing with a single cell. */
export function CellSelect({
  value,
  onChange,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  if (CELLS.length <= 1) {
    return null;
  }
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={cn("w-[150px]", className)}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Cell: All cells</SelectItem>
        {CELLS.map((cell) => (
          <SelectItem key={cell.id} value={cell.id}>
            Cell: {cell.residency}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
